import {
  UPDATE_PAGE
} from '../Actions/pageActions'

const initialState = {
  currentPage: null
}

export default function pageReducer (state = initialState, action) {
  switch (action.type) {
    case UPDATE_PAGE:
      return {
        ...state,
        currentPage: action.currentPage
      }
    default:
      return state
  }
}
